<template>
    <div class="w-full flex justify-center items-center gap-3 mb-5">
        <IconsLine class="bg-linear-to-r from-warning-700 to-warning-200" />
        <ChipsBase type="Secondary" variant="warning" class="text-center">
            <slot />
        </ChipsBase>
        <IconsLine class="rotate-180 bg-linear-to-r from-warning-700 to-warning-200" />
    </div>
</template>